export class PagenationModel {
  constructor(
    private pageNum: number,
    public totalNum: number,
    public startDispNum: number,
    public endDispNum: number
  ) { }

  prevPageNum() {
    return this.pageNum === 1 ? 1 : this.pageNum - 1;
  }

  currentPageNum() {
    return this.pageNum;
  }

  nextPageNum() {
    return this.pageNum + 1;
  }

  btnBackEnabled() {
    return this.pageNum > 1;
  }

  btnNextEnabled() {
    return this.totalNum > this.endDispNum;
  }

}